
import hash from './hasher.js';

const defaultState = Object.freeze({
        sampleData: "sample data",
        difficulty: 4,
        nonce: 1,
        resultingHash: hash("sample data" + 1),
        autoMining: false,
        backgroundMining: false,
    });

export default function blockMiningReducer(state = defaultState, action = {type:'NO-OP'}) {
    switch( action.type ) {
        case 'MINING-EDIT-DATA':
            return recalculateHash(miningEditData(state, action));
        case 'MINING-ADJUST-DIFFICULTY':
            return miningAdjustDifficulty(state, action);
        case 'MINING-SET-NONCE':
            return recalculateHash(miningSetNonce(state, action));
        case 'MINING-AUTO-TOGGLE':
            return miningAutoToggle(state, action);
        case 'MINING-BACKGROUND-START':
            return miningBackground(state, action);
        case 'MINING-BACKGROUND-DONE':
            return recalculateHash(miningBackgroundDone(state, action));
        default:
            return state;
    }
}


function miningEditData(state, action) {
    return {
        ...state,
        sampleData: action.content || "",
        autoMining: false,
    };
}
function miningAdjustDifficulty(state, action) {
    if( !action || action.level < 1 ) {
        return state;
    }

    return {
        ...state,
        difficulty: action.level,
        autoMining: false,
    };
}
function miningSetNonce(state, action) {
    if( !action || action.value < 1 ) {
        return state;
    }

    try {
       const num = parseInt(action.value, 10);
       return {
           ...state,
           nonce: num,
           autoMining: state.autoMining && action.value > state.nonce,
       };
    }
    catch(e) {
        return state;
    }
}

function recalculateHash(state) {
    const result = hash(state.sampleData + state.nonce);
    let success = true;
    for( let i = 0; i < state.difficulty; i++ ) {
        if( result[i] !== '0' ) {
            success = false;
            break;
        }
    }

    return {
        ...state,
        resultingHash: result,
        autoMining: state.autoMining && !success,
    };
}

function miningAutoToggle(state, action) {
    return {
        ...state,
        autoMining: !state.autoMining,
    };
}

function miningBackground(state, action) {
    return {
        ...state,
        autoMining: false,
        backgroundMining: true,
    };
}

function miningBackgroundDone(state, action) {
    return {
        ...state,
        autoMining: false,
        backgroundMining: false,
        nonce: action.nonce,
    };
}




// WEBPACK FOOTER //
// ./src/reducers/block-mining-reducer.js